var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from '../ui';
export var SkillsList = function (_a) {
    var skills = _a.skills, isSkillChipFilterable = _a.isSkillChipFilterable, setFilters = _a.setFilters;
    var _b = useState(false), allSkillVisible = _b[0], setAllSkillVisible = _b[1];
    if (!(skills === null || skills === void 0 ? void 0 : skills.length))
        return null;
    return (_jsxs("div", { className: 'flex flex-wrap gap-1', children: [(allSkillVisible ? skills : skills.slice(0, 6)).map(function (skill) { return (_jsx("div", { onClick: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    isSkillChipFilterable
                        ? setFilters === null || setFilters === void 0 ? void 0 : setFilters(function (filter) { return (__assign(__assign({}, filter), { appliedFilters: __spreadArray(__spreadArray([], filter.appliedFilters, true), [
                                {
                                    label: skill.skill_name,
                                    value: skill.skill_id,
                                    queryKey: 'skill',
                                },
                            ], false) })); })
                        : setFilters === null || setFilters === void 0 ? void 0 : setFilters(function (filter) { return (__assign(__assign({}, filter), { search: skill.skill_name })); });
                }, className: 'px-3 py-1 rounded-full border-2 border-vjwPrimary text-vjwPrimary text-sm hover:bg-blue-50 cursor-pointer', children: skill.skill_name }, skill.skill_id)); }), skills.length > 6 && (_jsx(Button, { variant: 'text', onClick: function () { return setAllSkillVisible(!allSkillVisible); }, className: 'text-vjwPrimary hover:underline text-sm px-0 py-0', children: allSkillVisible ? 'Show Less' : "+".concat(skills.length - 6, " More") }))] }));
};
